// extracted by css-extract-rspack-plugin
export default {"header":"R5jIRAOiBM9xj7zX","actionsBar":"Y5XgcsSDDoc0QhXg","actionsBarChild":"GXqobLlvXZM3pZB_","table":"cVsl9zf_xfgctUOR"};